/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CostDto } from './costDto';

export interface FeatureDto { 
    uuid?: string;
    name?: string;
    names?: { [key: string]: string; };
    descriptions?: { [key: string]: string; };
    phase?: FeatureDto.PhaseEnum;
    types?: Array<FeatureDto.TypesEnum>;
    usageType?: FeatureDto.UsageTypeEnum;
    usageLimit?: FeatureDto.UsageLimitEnum;
    cost?: CostDto;
    ignorePlayersOrder?: boolean;
    triggers?: Array<string>;
    featurableUuid?: string;
}
export namespace FeatureDto {
    export type PhaseEnum = 'StartOfTurn' | 'Trade' | 'CityManagement' | 'Movement' | 'Research';
    export const PhaseEnum = {
        StartOfTurn: 'StartOfTurn' as PhaseEnum,
        Trade: 'Trade' as PhaseEnum,
        CityManagement: 'CityManagement' as PhaseEnum,
        Movement: 'Movement' as PhaseEnum,
        Research: 'Research' as PhaseEnum
    };
    export type TypesEnum = 'NoOperation' | 'Military' | 'Demilitarization' | 'Attack' | 'Defense' | 'Healing' | 'WinBonus' | 'Building' | 'BuildingDesctruction' | 'Trade' | 'Technology' | 'Culture' | 'CultureIncrease' | 'Economic' | 'BuildCity' | 'CityDestruction' | 'Movement' | 'GreatPerson' | 'GreatPersonDestruction' | 'CancelCityAction' | 'Cancel' | 'Government' | 'Production' | 'Resources' | 'Wonder' | 'WonderDesctruction' | 'Figure' | 'Army' | 'Scout' | 'FigureDestruction' | 'Terraforming' | 'Unit';
    export const TypesEnum = {
        NoOperation: 'NoOperation' as TypesEnum,
        Military: 'Military' as TypesEnum,
        Demilitarization: 'Demilitarization' as TypesEnum,
        Attack: 'Attack' as TypesEnum,
        Defense: 'Defense' as TypesEnum,
        Healing: 'Healing' as TypesEnum,
        WinBonus: 'WinBonus' as TypesEnum,
        Building: 'Building' as TypesEnum,
        BuildingDesctruction: 'BuildingDesctruction' as TypesEnum,
        Trade: 'Trade' as TypesEnum,
        Technology: 'Technology' as TypesEnum,
        Culture: 'Culture' as TypesEnum,
        CultureIncrease: 'CultureIncrease' as TypesEnum,
        Economic: 'Economic' as TypesEnum,
        BuildCity: 'BuildCity' as TypesEnum,
        CityDestruction: 'CityDestruction' as TypesEnum,
        Movement: 'Movement' as TypesEnum,
        GreatPerson: 'GreatPerson' as TypesEnum,
        GreatPersonDestruction: 'GreatPersonDestruction' as TypesEnum,
        CancelCityAction: 'CancelCityAction' as TypesEnum,
        Cancel: 'Cancel' as TypesEnum,
        Government: 'Government' as TypesEnum,
        Production: 'Production' as TypesEnum,
        Resources: 'Resources' as TypesEnum,
        Wonder: 'Wonder' as TypesEnum,
        WonderDesctruction: 'WonderDesctruction' as TypesEnum,
        Figure: 'Figure' as TypesEnum,
        Army: 'Army' as TypesEnum,
        Scout: 'Scout' as TypesEnum,
        FigureDestruction: 'FigureDestruction' as TypesEnum,
        Terraforming: 'Terraforming' as TypesEnum,
        Unit: 'Unit' as TypesEnum
    };
    export type UsageTypeEnum = 'Necessary' | 'Confirmation' | 'Optional';
    export const UsageTypeEnum = {
        Necessary: 'Necessary' as UsageTypeEnum,
        Confirmation: 'Confirmation' as UsageTypeEnum,
        Optional: 'Optional' as UsageTypeEnum
    };
    export type UsageLimitEnum = 'Permanent' | 'Unlimited' | 'OncePerFeaturable' | 'OncePerTurnPerFeaturable' | 'OncePerBattle' | 'OncePerPhase' | 'OncePerPhasePerCity' | 'OncePerTurn' | 'OncePerGame' | 'OnceInGeneralSetup' | 'OnceInPlayerSetup';
    export const UsageLimitEnum = {
        Permanent: 'Permanent' as UsageLimitEnum,
        Unlimited: 'Unlimited' as UsageLimitEnum,
        OncePerFeaturable: 'OncePerFeaturable' as UsageLimitEnum,
        OncePerTurnPerFeaturable: 'OncePerTurnPerFeaturable' as UsageLimitEnum,
        OncePerBattle: 'OncePerBattle' as UsageLimitEnum,
        OncePerPhase: 'OncePerPhase' as UsageLimitEnum,
        OncePerPhasePerCity: 'OncePerPhasePerCity' as UsageLimitEnum,
        OncePerTurn: 'OncePerTurn' as UsageLimitEnum,
        OncePerGame: 'OncePerGame' as UsageLimitEnum,
        OnceInGeneralSetup: 'OnceInGeneralSetup' as UsageLimitEnum,
        OnceInPlayerSetup: 'OnceInPlayerSetup' as UsageLimitEnum
    };
}